// frontend/src/pages/Home.jsx
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import PlansSection from "../components/pages/home/PlansSection";
import { useEffect } from "react";
import Footer from "../components/pages/home/Footer";
import lightHeroImg from "../media/img/Home.png";
import { useTheme } from "../context/ThemeContext";
import { updatePageTitle } from "../utils/titleUtils";
import Features from "../components/pages/home/Features";
import HeroSection from "../components/pages/home/HeroSection";
import Featured from "../components/pages/home/Featured";
import About from "../components/pages/home/About";
import Testimonials from "../components/pages/home/Testimonials";
import HowItWorks from "../components/pages/home/HowItWorks";
import FAQ from "../components/pages/home/FAQ";
import Details from "../components/pages/home/Details";

const Home = () => {
  // Get current theme to determine which hero image to show
  const { theme } = useTheme();

  useEffect(() => {
    updatePageTitle("Home");
  }, []);

  // Determine which hero image to use based on theme
  const currentHeroImg = lightHeroImg;

  return (
    <div className="min-h-screen bg-bg-50 custom-scrollbar">
      {/* Hero Section with Header */}
      <div className="relative overflow-hidden bg-bg-60">
        <HeroSection currentHeroImg={currentHeroImg} />
      </div>

      {/* Featured Section */}
      {/* <Featured /> */}

      {/* About Section */}
      <About />

      {/* Features Section */}
      <div id="features" className="bg-bg-60">
        <Features />
      </div>

      {/* How It Works Section */}
      <HowItWorks />

      {/* Details Section */}
      <Details />

      {/* Testimonials Section */}
      {/* <Testimonials /> */}

      {/* Plans Section */}
      <div id="plans">
        <PlansSection />
      </div>

      {/* FAQ Section */}
      <FAQ />

      {/* Footer */}
      <Footer />
    </div>
  );
};
export default Home;
